import { render, staticRenderFns } from "./AuthInvite.vue?vue&type=template&id=ded081e8&"
import script from "./AuthInvite.vue?vue&type=script&lang=js&"
export * from "./AuthInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports